import { requestGet } from '../utils/request';

const BASE_URL_ACCESIBLE = '/api/v5/fields/accessible';
const BASE_URL_OWNED = '/api/v5/fields/owned';

/**
 * Get Fields Data
 * @param {String} userId the impersonated user's id
 * @param {String} nextToken token used by the pagination on Homestead
 * @return {Promise} Response
 */
export function requestFields(userId, nextToken) {
  let options = {
    mockFile: 'fields/default',
    fullResponse: true,
  };
  if (nextToken) {
    options = { ...options, headers: { 'x-next-token': nextToken } };
  }
  const baseURL = userId
    ? `${BASE_URL_OWNED}?userId=${userId}`
    : BASE_URL_ACCESIBLE;
  return requestGet(baseURL, options);
}
